import React, { useState, useCallback, useEffect } from "react";
import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Category } from "../../../components/design/layout/scrollable-categories";
import Layout from "../../../components/patterns/subpages/layout";

import CategorizationService from "../../../services/Categorization";

import loadImage from "../../../utils/LoadImage";

import { CategoriesContent } from './styles';
import { useTheme } from "styled-components";

const useStyles = makeStyles((theme) => ({
    item: {
        textAlign: "center",
    },
    category: {
        marginLeft: "auto !important",
        marginRight: "auto",
    }
}));

function Categories({ website }) {
    const classes = useStyles();
    const history = useHistory();
    const handleHistory = () => history.goBack();

    const theme = useTheme();

    const [categorization, setCategorization] = useState([]);

    const handleListCategorization = useCallback(() => {
        const categorizationService = new CategorizationService();

        categorizationService.list().then((response) => {
            setCategorization(response.data.payload);
        });
    }, []);

    useEffect(() => {
        handleListCategorization();
    }, [handleListCategorization]);

    return (
        <>
            <Layout headContent="Categorias" backHistoryEvent={handleHistory} >
                <CategoriesContent>

                    <Grid container spacing={2}>
                        {categorization.map((item) => (
                            <Grid className={classes.item} item xs={4}>
                                <Category
                                    title={item.nome}
                                    caregoriesBorderColor={theme[website].pages.categories.itemBorderColor}
                                    category={item}
                                    className={classes.category}
                                    categoryImage={loadImage({ imageCode: item.imagem })}
                                    params={`&tail=categories`}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </CategoriesContent>
            </Layout>
        </>
    )
}

const mapStateToProps = (state) => ({
    website: state.websiteReducer.website
})

export default withRouter(connect(mapStateToProps, {})(Categories));